import React from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import Rollbar from 'rollbar';

import App from './App';
import { store } from './redux/store';

import './Common/I18n';
import './utils/broadcast-channel-polyfill';
import './utils/onchange-cookie';
import 'bootstrap/dist/css/bootstrap.min.css';

import './assets/scss/index.scss';

import { Provider as LoggerProvider, ErrorBoundary } from '@rollbar/react'; // Provider imports 'rollbar'

const rollbarConfig = {
  accessToken: '302c0fb5b5b8435ea62e85288af4501c',
  environment: 'production',
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: process.env.NODE_ENV === 'production',
};

export const rollbar = new Rollbar(rollbarConfig);

export const throwErrorRollbar = error => {
  const user = JSON.parse(localStorage.getItem('user'));
  error.name = `${user && user.email ? user.email : 'undefined email '}\n` + error.name;
  rollbar.error(error);
};

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <LoggerProvider config={rollbar}>
    <ErrorBoundary>
      <Toaster
        position="bottom-left"
        reverseOrder={false}
        toastOptions={{
          success: {
            style: {
              background: '#50C878',
              fontWeight: '500',
            },
          },
        }}
      />
      {/* // <I18nextProvider i18n={i18n}> */}
      <BrowserRouter>
        <Provider store={store}>
          <App />
        </Provider>
      </BrowserRouter>
      {/* // </I18nextProvider>, */}
    </ErrorBoundary>
  </LoggerProvider>,
);
